import { Center, Spinner as ChakraSpinner } from "@chakra-ui/react";
import React from "react";

const Spinner = () => {
  return (
    <Center>
      <ChakraSpinner
        boxSize="5rem"
        thickness="8px"
        speed="1s"
        emptyColor="gray.200"
        color="blue.500"
      />
    </Center>
  );
};

export default Spinner;
